import React, { useCallback, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { ActivityImage, HandsImage, MoneyImage, PeoplesImage } from 'src/assets';
import './investInfo.scss';
import { useAnimatedView } from 'src/hooks/useAnimatedView';

export const InvestInfo = () => {
  const { t } = useTranslation();

  const renderInfoItem = useCallback((image, title, subTitle) => {
    return (
      <div className="investInfo-info-item">
        <img src={image} alt={image} />
        <div className="investInfo-info-item-content">
          <h1 className="investInfo-info-item-title">{title}</h1>
          <div className="investInfo-info-item-subtitle">{subTitle}</div>
        </div>
      </div>
    );
  }, []);

  const ref = useRef();
  const { isVisible } = useAnimatedView(ref);

  return (
    <div className="investInfo">
      <div className={`investInfo-content ${isVisible ? 'active-animation' : ''}`} ref={ref}>
        <div className="investInfo-info">
          <div className="investInfo-info-background" />
          <div className="investInfo-info-content">
            {renderInfoItem(PeoplesImage, '35.000+', t('investments:clients'))}
            {renderInfoItem(ActivityImage, '150+', t('investments:assets'))}
            {renderInfoItem(MoneyImage, `$ 2${t('investments:moneyType')}`, t('investments:money'))}
            {renderInfoItem(HandsImage, '0.5s', t('investments:orders'))}
          </div>
        </div>
      </div>
    </div>
  );
};
